
import useMetadata from "@/hooks/data/useMetadata";
import { createContext } from "react"

export interface IMetadataContext extends ReturnType<typeof useMetadata> {
}

export const MetadataContext = createContext<IMetadataContext>({
    data: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default MetadataContext;